import { render } from "./index-search-top.vue?vue&type=template&id=e229856c&scoped=true"
import script from "./index-search-top.vue?vue&type=script&lang=js"
export * from "./index-search-top.vue?vue&type=script&lang=js"

import "./index-search-top.vue?vue&type=style&index=0&id=e229856c&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e229856c"]])

export default __exports__